<div class="container-fluid" *ngIf="isLoaded" [@fadeInAnimation]>
  <div class="row">
    <div class="col-xl-1"></div>
    <div class="col-xl-10">
      <div class="card mb-3">
        <div class="card-header">
          <fa-icon [icon]="['fas', 'gavel']" size="lg" class="mr-2" [fixedWidth]="true"></fa-icon>{{ huvudB2.arende.arendeTyp.typ==='rek' ? 'R' : 'B' }}2 (samlingsbeslut) {{ huvudB2.arende.galdenar.namn }} {{ huvudB2.datum | localizeddate:'shortDate' }}
        </div>
        <div class="card-body">
          <a *ngIf="huvudB2.b2Beslut.length >= 10" [routerLink]="['/mina-arenden', huvudB2.arende.id]" class="btn-garanti btn-blue mb-3"><fa-icon [icon]="['fas', 'arrow-left']" class="mr-2"></fa-icon>Tillbaka till ärendet</a>
          <ng-container *ngIf="!!huvudB2.kommantarOvrigt">
            <p class="h5">Kommentar</p>
            <p class="text-monospace">{{ huvudB2.kommantarOvrigt }}</p>
          </ng-container>
          <ng-container *ngIf="!!huvudB2.handlaggarensNotering">
            <p class="h5">Handläggarens notering</p>
            <p class="text-monospace">{{ huvudB2.handlaggarensNotering }}</p>
          </ng-container>

          <hr *ngIf="!!huvudB2.kommantarOvrigt || !!huvudB2.handlaggarensNotering" />

          <p class="h5">Delbeslut</p>

          <div class="form-group">
            <div class="input-group">
              <div class="input-group-prepend">
                <span class="input-group-text">
                  <fa-icon [icon]="['fas', 'filter']" [fixedWidth]="true"></fa-icon>
                </span>
              </div>
              <input [(ngModel)]="filterText" type="text" name="filter" class="form-control rounded-right" placeholder="Filtrera..." (ngModelChange)="applyFilter(newValue)">
            </div>
          </div>

          <div class="table-responsive" *ngIf="huvudB2.b2Beslut.length">
            <table class="table table-hover">
              <thead>
                <tr>
                  <th scope="col" [class.order-active]="orderName==='fornamn'" (click)="setOrder('fornamn', ['anstallning.arbetstagare.fornamn'])">
                    <div class="d-flex justify-content-between">
                      Förnamn
                      <fa-icon [icon]="['fas', reverse ? 'sort-amount-down' : 'sort-amount-up']" class="ml-2" [flip]="reverse||'vertical'"></fa-icon>
                    </div>
                  </th>
                  <th scope="col" [class.order-active]="orderName==='efternamn'" (click)="setOrder('efternamn', ['anstallning.arbetstagare.efternamn'])">
                    <div class="d-flex justify-content-between">
                      Efternamn
                      <fa-icon [icon]="['fas', reverse ? 'sort-amount-down' : 'sort-amount-up']" class="ml-2" [flip]="reverse||'vertical'"></fa-icon>
                    </div>
                  </th>
                  <th scope="col" [class.order-active]="orderName==='personNr'" (click)="setOrder('personNr', ['anstallning.arbetstagare.personNr12Siffror'])">
                    <div class="d-flex justify-content-between">
                      Personnummer
                      <fa-icon [icon]="['fas', reverse ? 'sort-amount-down' : 'sort-amount-up']" class="ml-2" [flip]="reverse||'vertical'"></fa-icon>
                    </div>
                  </th>
                  <th scope="col" [class.order-active]="orderName==='lg'" (click)="setOrder('lg', ['lgBeloppTotal_cache'])">
                    <div class="d-flex justify-content-between">
                      <fa-icon [icon]="['fas', reverse ? 'sort-amount-down' : 'sort-amount-up']" class="mr-2" [flip]="reverse||'vertical'"></fa-icon>
                      Lönegaranti
                    </div>
                  </th>
                  <th scope="col" [class.order-active]="orderName==='fordran'" (click)="setOrder('fordran', ['fordranBeloppTotal_cache'])">
                    <div class="d-flex justify-content-between">
                      <fa-icon [icon]="['fas', reverse ? 'sort-amount-down' : 'sort-amount-up']" class="mr-2" [flip]="reverse||'vertical'"></fa-icon>
                      Fordran
                    </div>
                  </th>
                  <!--<th scope="col" [class.order-active]="getOrder==='harFil'" (click)="setOrder(['harFil'])">
                    <div class="d-flex justify-content-between">
                      Dokument
                      <fa-icon [icon]="['fas', reverse ? 'sort-amount-down' : 'sort-amount-up']" class="ml-2" [flip]="reverse||'vertical'"></fa-icon>
                    </div>
                  </th>-->
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let b of huvudB2.b2Beslut | orderBy: order:reverse:'case-insensitive' | filterBy: userFilter" [routerLink]="['/anstallning', b.anstallning.id]">
                  <td data-name="Förnamn" title="Förnamn"><span [class.redacted]="b.anstallning.isConfidential">{{ b.anstallning.arbetstagare.fornamn }}</span></td>
                  <td data-name="Efternamn" title="Efternamn"><span [class.redacted]="b.anstallning.isConfidential">{{ b.anstallning.arbetstagare.efternamn }}</span></td>
                  <td data-name="Personnumer" title="Personnummer"><span [class.redacted]="b.anstallning.isConfidential">{{ b.anstallning.arbetstagare.personNr12Siffror }}</span></td>
                  <td data-name="Lönegaranti" title="Lönegaranti i kronor" class="text-right-sm-left" [ngClass]='{ "fordran-lg-diff": b.lgBeloppTotal_cache !== b.fordranBeloppTotal_cache && b.fordranBeloppTotal_cache > 0 && b.lgBeloppTotal_cache <= huvudB2.arende.lgMaxBelopp, "lg-over-max": b.lgBeloppTotal_cache > huvudB2.arende.lgMaxBelopp }'>{{ b.lgBeloppTotal_cache | localizednumber }} kr</td>
                  <td data-name="Fordran" title="Fordran i kronor" class="text-right-sm-left" [ngClass]='{ "fordran-lg-diff": b.lgBeloppTotal_cache !== b.fordranBeloppTotal_cache && b.fordranBeloppTotal_cache > 0 }'>{{ b.fordranBeloppTotal_cache | localizednumber }} kr</td>
                  <!--<td data-name="Dokument" *ngIf="b.harFil">
                    <file-link [file]="b.fil"></file-link>
                  </td>
                  <td data-name="Dokument" *ngIf="!b.harFil">
                    &ndash;
                  </td>-->
                </tr>
              </tbody>
              <tfoot *ngIf="(huvudB2.b2Beslut | filterBy: userFilter).length > 1">
                <tr>
                  <th colspan="3" title="Antal delbeslut">{{ (huvudB2.b2Beslut | filterBy: userFilter).length | localizednumber }} delbeslut</th>
                  <th class="text-right" title="Total lönegaranti i kronor">{{ getSum(huvudB2.b2Beslut | filterBy: userFilter, 'lgBeloppTotal_cache') | localizednumber }} kr</th>
                  <th class="text-right" title="Total fordran i kronor">{{ getSum(huvudB2.b2Beslut | filterBy: userFilter, 'fordranBeloppTotal_cache') | localizednumber }} kr</th>
                  <!--<th></th>-->
                </tr>
              </tfoot>
            </table>
            <div class="container-fluid mb-3" *ngIf="role==='adv'">
              <div class="row">
                <button [disabled]="!!huvudB2.attest" (click)="attestHuvudB2()" class="btn-garanti btn-blue ml-auto"><fa-icon [icon]="['fas', 'marker']" class="mr-2"></fa-icon>Attestera denna {{ huvudB2.arende.arendeTyp.typ==='rek' ? 'R' : 'B' }}2:a</button>
                <p class="text-muted" *ngIf="!(huvudB2.b2Beslut | filterBy: userFilter).length">Inga träffar</p>
              </div>
            </div>
          </div>
          <p class="text-muted" *ngIf="!huvudB2.b2Beslut.length">Inga delbeslut</p>

          <hr />

          <p class="h5">{{ huvudB2.arende.arendeTyp.typ==='rek' ? 'R' : 'B' }}2:ans bilagor</p>

          <div class="table-responsive" *ngIf="huvudB2.filer.length">
            <table class="table">
              <thead>
                <tr>
                  <th scope="col" style="width:120px">Datum</th>
                  <th scope="col">Beskrivning</th>
                  <th scope="col" style="width:140px">Dokument</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let d of huvudB2.filer | orderBy: ['-datumSparat', 'beskrivning']">
                  <td data-name="Datum" title="Datum">{{ d.datumSparat | localizeddate:'shortDate' }}</td>
                  <td data-name="Beskrivning" title="Beskrivning">{{ d.beskrivning }}</td>
                  <td data-name="Dokument" title="Dokument" class="beslut-file"><file-link [file]="d"></file-link></td>
                </tr>
              </tbody>
            </table>
            <p class="text-muted" *ngIf="!huvudB2.filer.length">Inga bilagor</p>
          </div>

          <a [routerLink]="['/mina-arenden', huvudB2.arende.id]" class="btn-garanti btn-blue"><fa-icon [icon]="['fas', 'arrow-left']" class="mr-2"></fa-icon>Tillbaka till ärendet</a>
        </div>
      </div>
    </div>
  </div>
</div>
